export enum MimeType {
  ApplicationPdf = 'application/pdf',
  ImageJpeg = 'image/jpeg',
  ImagePng = 'image/png',
}
